import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import type FeaturesService from 'teacher-ui-client/services/features'
import type DashboardPreferencesService from 'teacher-ui-client/services/dashboard-preferences'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'

export class TeacherHomeSidenavLink extends Component {
  @service features!: FeaturesService
  @service('dashboard-preferences') dashboardPreferences!: DashboardPreferencesService

  get isVisible() {
    return this.features.isEnabled('tui_teacher_home') && this.dashboardPreferences.teacherHomeOptedIn
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem data-test-side-nav-teacher-home @linkTo="subscription-type.teacher-home">
        <SideNavIconComponent @phosphorIcon="phosphor-chart-line-bold" />
        <span>{{t "sideNav.myInsights"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default TeacherHomeSidenavLink
